import {
  BreakLine,
  Card,
  CardSectionHeader,
  CheckPoint,
  CardHeader,
  CardSubHeader,
  Row,
  StatusTable,
  ConnectingCheckPoints,
  Loader,
  RadioButtons,
  RadioOrSelect,
  CardLabel,
  UploadFile,
  Dropdown,
} from "@egovernments/digit-ui-react-components";
import DownloadIcon from "@mui/icons-material/Download";
import { useTranslation } from "react-i18next";
import React, { useEffect, useRef, useState, Fragment } from "react";
import { Tab, Tabs, Box, Checkbox, FormGroup, FormControlLabel, Select, OutlinedInput, FormControl } from "@mui/material";
import TabPanel from "@egovernments/digit-ui-module-obps/src/pageComponents/TabPanel";
import TLCaption from "../../obps/src/components/TLCaption";
// import Button from "@mui/material/Button";
import DemoParinted from "../ApplicationDetails/components/RichTextArea";
import { styled } from "@mui/styles";
import { Toast } from "@egovernments/digit-ui-react-components";
import EmployeeComponent from "../ApplicationDetails/RoleAccess/Employer";
import Structural from "../ApplicationDetails/RoleAccess/StructuralEngineer";
import Architect from "../ApplicationDetails/RoleAccess/Architect";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import BPAApplicationTimeline from "@egovernments/digit-ui-module-obps/src/pages/citizen/BpaApplicationDetail/BPAApplicationTimeline";
import axios from "axios";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import { useParams, useHistory } from "react-router-dom";
import LandUseNOC from "@egovernments/digit-ui-module-obps/src/components/LandUseNOC/LandUseNOC";
// import LandUseActionNoc from "./LandUseActionNoc";
import { useSelector } from "react-redux";
import { Button, Dialog, DialogActions, DialogContentText, DialogTitle } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import Swal from "sweetalert2";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import ViewLandUseNoc from "./ViewLandUseNoc";
import EMOCheckList from "@egovernments/digit-ui-module-obps/src/pages/citizen/TCPForms/formComponents/owner-registration/EMOChecklist";
import PurchasableFarChecklist from "@egovernments/digit-ui-module-obps/src/components/EmployeeChecklist/PurchasableFarChecklist";
import AllRemarksList from "./AllRemarks";
import FarDetails from "@egovernments/digit-ui-module-obps/src/components/EmployeeFarDetails/FarDetails";
import ChecklistFarCitizen from "@egovernments/digit-ui-module-obps/src/components/CitizenChecklist/ChecklistFarCitizen";
import CitizenFarDetails from "@egovernments/digit-ui-module-obps/src/components/CitizenFarDetails/CitizenFarDetails";
// import LandUseNOC2 from "@egovernments/digit-ui-module-obps/src/components/LandUseNOC/LandUseNOC2";
import { SelectMandatoryConditions } from "./SelectMandatoryConditions";
import FarPaymentOption from "@egovernments/digit-ui-module-obps/src/components/FarPaymentOption/FarPaymentOption";
import FarPaymentDisplay from "@egovernments/digit-ui-module-obps/src/components/FarPaymentDisplay/FarPaymentDisplay";
import Summary from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/purchasable-Far/summary/Summary";
import CollapsibleHistory from "@egovernments/digit-ui-module-obps/src/pages/employee/NotingRemarks";
import { StyledMenuItem } from "@egovernments/digit-ui-module-obps/src/pages/citizen/TCPForms/forms/StyledComponents";
import ChatBoard from "@egovernments/digit-ui-module-obps/src/components/ChatBoard";

import DocumentSection from "@egovernments/digit-ui-module-obps/src/pages/employee/PurchasableFAR/DocumentSection";
import ChatboardCorrespondenceApplicant from "@egovernments/digit-ui-module-obps/src/components/ChatBoard/ChatBoardApplicant/ChatBoardCorrespondenceApplicant";
import { SelectMandatoryConditions2 } from "./SelectMandatoryConditions2";
import { citizenBaseUrl } from "@egovernments/digit-ui-module-core/src/pages/citizen/citizenPageUrls";
// import { OBPSService } from "@egovernments/digit-ui-libraries/src/services/elements/OBPS";
const StyledTabPanel = styled(TabPanel)(() => ({
  "& .MuiBox-root": { padding: "1px" },
}));

const stripHtmlTags = (html) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.innerText || tempDiv.textContent || ""; // Get the plain text
};
const FormSummary = ({
  formData,
  businessService,
  action,
  setOnAddComments,
  onActionSelect,
  showTimeLine = true,
  applicationData,
  workflowDetails,
  timelineStatusPrefix,
  isDataLoading,
  statusAttribute = "status",
  submitAction,
  actionData,
  moduleCode,
}) => {
  const conponentPDF = useRef();
  const [officerNocDetails, setOfficerNocDetails] = useState(formData?.nocDetails);
  const reduxFormData = useSelector((state) => state?.formLandUse); //land use form
  const selectChecklist = useSelector((state) => state.checkList); // owner registration form
  const purchasableFarChecklist = useSelector((state) => state.purchasableFarChecklist); // purchasableFar form
  console.log("farChecklist", purchasableFarChecklist);
  console.log("reduxLandUSe", reduxFormData, officerNocDetails);

  const [currentTab, setCurrentTab] = useState("0");
  const [mandatoryCondition, setMandatoryCondition] = useState("");
  const [reviewedData, setReviewedData] = useState(formData?.checklistReview);
  const [fetchedPaymentData, setFetchedPaymentData] = useState({});
  const [isNoNoc, setIsNoNoc] = useState(true);
  const isLowRiskCase = formData?.riskType === "LOW";

  // formData?.descriptionOfLand.schemeType === "Scheme" &&
  // formData?.descriptionOfLand?.landUsesType === "Residential" &&
  // formData?.descriptionOfLand?.subLandUseAsPerLayout === "Residential" &&
  // formData?.descriptionOfLand?.landArea <= 2000;
  console.log("reviewedData", reviewedData);
  useEffect(() => {
    !!purchasableFarChecklist.checklistReview.checklistReview
      ? setReviewedData(purchasableFarChecklist.checklistReview.checklistReview)
      : setReviewedData(formData?.checklistReview);
  }, [purchasableFarChecklist.checklistReview.checklistReview]);

  // If checklist updated by employee than updated checklist else checklist fetched from previous employee
  const applicationFlow = Digit?.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
  const tcpCode = applicationFlow === "TCP";
  const udCode = applicationFlow === "UD";
  const { t } = useTranslation();
  const { id } = useParams();
  const history = useHistory();
  const Modal = useModal();
  const stateId = Digit.ULBService.getStateId();
  const tenantId = stateId;
  const [showToast, setShowToast] = useState(null);
  const [remarksData, setRemarksData] = useState(null);
  const [formDataNoc, setFormDataNoc] = useState({});
  const [structureCertificateError, setStructureCertificateError] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const closeToast = () => setShowToast(null);
  const appType = formData?.applicationType;
  const [currentAction, setCurrentAction] = useState(null);
  const [farDetails, setFarDetails] = useState({
    baseFar: formData?.descriptionOfLand?.properties?.[0]?.baseFar || 0,
    circleRate: formData?.descriptionOfLand?.properties?.[0]?.circleRate || 0,
  });
  console.log("apptype", appType, "tenentId", tenantId, "formData", formData, "remarksData6666666666", remarksData);

  const isOwnerReg = appType === "FORM_OWNER_REGISTRATION" && formData?.approvedLayout === "no";
  const isApprovedOwnerReg = appType === "FORM_OWNER_REGISTRATION" && formData?.approvedLayout === "yes";
  const isPurchasableFAR = appType === "FORM_PURCHASABLE_FAR";
  const isLandUse = appType === "FORM_LANDUSE";
  let user = Digit.UserService.getUser();
  const calculateInstallments = () => {
    return { paymentData, paymentLoading };
  };

  const tablist = [
    isPurchasableFAR && user?.info?.type !== "CITIZEN" && { label: "Application Data", color: "#fd6d0b" },
    isPurchasableFAR && user?.info?.type !== "CITIZEN" && { label: "Documents", color: "fd6d0b" },
    { label: "WF_TAKE_ACTION", color: "red" },
    { label: "ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS", color: "green" },
    isApprovedOwnerReg && { label: "CheckList", color: "#fd6d0b" }, // Owner Checklist
    isLandUse &&
      ((formData?.status === "APPROVED" && user?.info?.type === "CITIZEN") || user?.info?.type !== "CITIZEN") && {
        label: "WF_NOC_FORM",
        color: "#fd6d0b",
      }, // LandUse Checklist
    ...(isPurchasableFAR
      ? [
          { label: "Checklist", color: "#fd6d0b" },
          ...(user?.info?.type !== "CITIZEN" ? [{ label: "FAR Details", color: "#fd6d0b" }] : [{ label: "Fee Details", color: "#fd6d0b" }]),
        ]
      : []),
    isLandUse &&
      formData?.descriptionOfLand?.selectLandUse == "Conditional Permissible" &&
      user?.info?.type !== "CITIZEN" && {
        label: "Conditions",
        color: "#fd6d0b",
      }, // LandUse Checklist)
    { label: "Chatboard", color: "#fd6d0b" },
  ].filter(Boolean);
  const userRoles = user?.info?.roles?.map((e) => e.code);
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const userInfo = user?.info || {};
  const userRolesArray = userInfo?.roles.filter((user) => user.code !== "EMPLOYEE");
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");
  const updateOwnerCall = Digit.Hooks.obps.useObpsAPI(tenantId, "OWNER_REGISTRATION");
  const updatePurchasableFar = Digit.Hooks.obps.useObpsAPI(tenantId, "PURCHASABLE_FAR");
  console.log("iseOwnerReg", isOwnerReg, "isApprovedOwner", isApprovedOwnerReg, "user", user, "userRolesArray", userRolesArray);

  const BusinessService = formData?.businessService === `BPA_${appType?.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
  const { nocDocuments, PrevStateDocuments, PrevStateNocDocuments } = formData;
  const docs = formData?.documents || {};
  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;
  formData.documents = documents;
  ////// for action workflow
  const squareMeterArea = formData?.descriptionOfLand.properties?.[0].plotArea;

  let isbelowEE = squareMeterArea < 501;
  let isbelowEEAVP = squareMeterArea < 0;
  let isbelowTP = squareMeterArea < 501;
  let isbelowCTP = squareMeterArea < 2001;
  let isbelowVC = squareMeterArea > 2000;

  let isbelowNCTP = squareMeterArea < 501;
  let isbelowNVC = squareMeterArea > 500;
  let isbelowNVCNO = squareMeterArea > 0;
  // -----------------------------------------------

  const isEE = userRoles.includes("EE");
  const isTP = userRoles.includes("TP");
  const isCTP = userRoles.includes("CTP");
  const isVC = userRoles.includes("Vice_Chairman");
  // const empactions = workflowDetails?.data?.nextActions;
  console.log("workFlowDetails", workflowDetails);
  // Commercial
  let actions = workflowDetails?.data?.actionState?.nextActions?.filter((e) => {
    if (formData?.approvedLayout === "Yes" && formData?.businessService != "BPA_FAR_AVP") {
      if (formData?.applicationType === "FORM_PURCHASABLE_FAR" && formData?.descriptionOfLand.properties?.[0].landUseAsPerLayout === "Residential") {
        if (isbelowTP && isTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowTP &&
          isTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowEE && isEE && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEE &&
          isEE &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowCTP && isCTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowCTP &&
          isCTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowVC && isVC && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowVC &&
          isVC &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
      } else if (
        formData?.applicationType === "FORM_PURCHASABLE_FAR" &&
        formData?.descriptionOfLand.properties?.[0].landUseAsPerLayout != "Residential" &&
        formData?.descriptionOfLand.properties?.[0].landUseAsPerLayout != "Commercial"
      ) {
        if (isbelowEEAVP && isTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowEEAVP && isEE && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isEE &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowEEAVP && isCTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isCTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowNVCNO && isVC && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowNVCNO &&
          isVC &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
      } else if (
        formData?.applicationType === "FORM_PURCHASABLE_FAR" &&
        formData?.descriptionOfLand.properties?.[0].landUseAsPerLayout === "Commercial"
      ) {
        if (isbelowEEAVP && isTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowEEAVP && isEE && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isEE &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowNCTP && isCTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowNCTP &&
          isCTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowNVC && isVC && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowNVC &&
          isVC &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
      }
    } else if (formData?.approvedLayout === "No" && formData?.businessService != "BPA_FAR_AVP") {
      if (formData?.applicationType === "FORM_PURCHASABLE_FAR") {
        if (isbelowEEAVP && isTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowEEAVP && isEE && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isEE &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowEEAVP && isCTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isCTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowNVCNO && isVC && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowNVCNO &&
          isVC &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
      }
    }
    return userRoles.some((role) => e.roles?.includes(role)) || !e.roles;
  });
  console.log("actionsfromSummary", actions);

  // formData?.approvedLayout === "Yes"
  // descriptionOfLand.properties.[0].plotArea
  // descriptionOfLand.properties.[0].landUseAsPerLayout === "Residential"

  const [open, setOpen] = useState(false);
  const [developerRemarks, setDeveloperRemarks] = useState(null);
  const [developerRemarksValidation, setDeveloperRemarksValidation] = useState(null);
  const [purchasableFarActions, setPurchasableFarActions] = useState(null);
  const [currentActionCertification, setCurrentActionCertification] = useState(null);
  const [showTakeAction, setShowTakeAction] = useState("");
  const [structureCertificateUrl, setStructureCertificateUrl] = useState("");
  const [structureCertificateId, setStructureCertificateId] = useState("");
  const [checked, setChecked] = React.useState(false);
  const [updatedDocuments, setUpdatedDocuments] = useState(formData?.documents);
  setOnAddComments(developerRemarks);

  // Strip HTML tags and set validation state
  const handleRemarksValidation = () => {
    console.log("handleRenarksCalled");

    const plainText = stripHtmlTags(developerRemarks);
    if (plainText.trim().length === 0) {
      setDeveloperRemarksValidation("Developer remarks cannot be empty.");
    } else {
      setDeveloperRemarksValidation("Valid remarks entered");
    }
  };
  useEffect(() => {
    handleRemarksValidation();
  }, [developerRemarks]);
  const onRadioActionSelect = (value) => {
    // debugger;
    if (isPurchasableFAR) {
      console.log("radioAction", value);
      setPurchasableFarActions(value);
    } else {
      setCurrentAction(value);
    }
    function onSelect(val) {
      // debugger;
      if (val !== selectedOption || props.allowMultiselect) {
        props.select(val);
        setSelectedOption(val);
        setDropdownStatus(false);
      } else {
        setSelectedOption(val);
        setforceSet(forceSet + 1);
      }
    }
  };

  const onDropDownSelect = (event) => {
    const value = event.target.value;
    if (isPurchasableFAR) {
      console.log("radioAction", value);
      setPurchasableFarActions(value);
    } else {
      setCurrentAction(value);
    }
    function onSelect(val) {
      if (val !== selectedOption || props.allowMultiselect) {
        props.select(val);
        setSelectedOption(val);
        setDropdownStatus(false);
      } else {
        setSelectedOption(val);
        setforceSet(forceSet + 1);
      }
    }
  };
  const [typeOfLandVolved, setTypeOfLandVolved] = useState("");

  const selectedValueSelect = (value) => {
    setTypeOfLandVolved(value);
  };
  // for application documents
  let improvedDoc = [];
  PrevStateDocuments?.map((preDoc) => {
    improvedDoc.push({ ...preDoc, module: "OBPS" });
  });
  documents?.map((appDoc) => {
    improvedDoc.push({ ...appDoc, module: "OBPS" });
  });

  //for NOC documents
  PrevStateNocDocuments?.map((preNocDoc) => {
    improvedDoc.push({ ...preNocDoc, module: "NOC" });
  });
  nocDocuments?.nocDocuments?.map((nocDoc) => {
    improvedDoc.push({ ...nocDoc, module: "NOC" });
  });

  const { data: pdfDetails, isLoading: pdfLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, { enabled: improvedDoc?.length > 0 ? true : false });

  let applicationDocs = [],
    nocAppDocs = [];
  if (pdfDetails?.pdfFiles?.length > 0) {
    pdfDetails?.pdfFiles?.map((pdfAppDoc) => {
      if (pdfAppDoc?.module == "OBPS") applicationDocs.push(pdfAppDoc);
      if (pdfAppDoc?.module == "NOC") nocAppDocs.push(pdfAppDoc);
    });
  }

  let consumerCode = formData?.applicationNo;
  const fetchBillParams = { consumerCode };

  const { data: paymentDetails } = Digit.Hooks.useFetchBillsForBuissnessService(
    { businessService: BusinessService, ...fetchBillParams, tenantId: stateId },
    {
      enabled: consumerCode ? true : false,
      retry: false,
    }
  );
  const totalAmount = formData?.paymentDetails?.bill?.billDetails[0]?.amount || paymentDetails?.Bill?.[0]?.billDetails[0]?.amount;

  const handleChange = (event, nextTab) => {
    console.log("nextTab", typeof nextTab, nextTab, isApprovedOwnerReg, "owner");

    setCurrentTab(nextTab);
  };

  const handleChangeCheckBox = (event) => {
    setChecked(event.target.checked);
    // console.log("valueofcheck", event.target.checked);
  };
  const isEditApplication = window.location.href.includes("editApplication");
  const sendbacktocitizenApp = window.location.href.includes("sendbacktocitizen");
  let routeLink = `/digit-ui/citizen/obps/form11/${formData?.applicationType?.toLowerCase()}/${formData?.serviceType?.toLowerCase()}`;
  if (isEditApplication) routeLink = `/digit-ui/citizen/obps/editApplication/form11/${formData?.tenantId}/${formData?.applicationNo}`;
  if (sendbacktocitizenApp) routeLink = `/digit-ui/citizen/obps/sendbacktocitizen/form11/${formData?.tenantId}/${formData?.applicationNo}`;
  ////
  function OpenImage(imageSource, index, thumbnailsToShow) {
    window.open(thumbnailsToShow?.fullImage?.[0], "_blank");
  }
  const getTimelineCaptions = (checkpoint) => {
    if (checkpoint.state === "OPEN" || (checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/"))) {
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate(applicationData?.auditDetails?.createdTime),
        source: applicationData?.channel || "",
      };
      return <TLCaption data={caption} />;
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      const caption = {
        date: checkpoint?.auditDetails?.lastModified,
        name: checkpoint?.assignes?.[0]?.name,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
        comment: t(checkpoint?.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint?.thumbnailsToShow,
      };
      return <TLCaption data={caption} OpenImage={OpenImage} />;
    } else {
      const caption = {
        date: Digit.DateUtils?.ConvertTimestampToDate(applicationData?.auditDetails?.lastModifiedTime),
        name: checkpoint?.assignes?.[0]?.name,
        wfComment: checkpoint?.wfComment,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
      };
      return <TLCaption data={caption} />;
    }
  };
  function routeTo(jumpTo) {
    location.href = jumpTo;
  }

  ///////////////////////////////////
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file?.type && !allowedFileTypesRegex.test(file?.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || tenantId?.split(".")[0]);
            if (response?.data?.files?.length > 0) {
              setUploadedFile(response?.data?.files[0]?.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);

  const tenant = Digit.ULBService.getCurrentTenantId();

  const getUserInfo = async () => {
    // console.log("sfkdkfdj");
    const uuid = user?.info?.uuid;
    if (uuid) {
      const usersResponse = await Digit.UserService.userSearch(tenant, { uuid: [uuid] }, {});
      usersResponse && usersResponse.user && usersResponse.user.length && setUserDetails(usersResponse.user[0]);
    }
  };
  const signatureAccess = userDetails?.signature;
  useEffect(() => {
    // console.log("4594540");
    getUserInfo();
  }, [user?.info?.uuid]);
  /////////
  const getInspectionDocs = (docs) => {
    let refinedDocs = [];
    docs &&
      docs.map((doc, ind) => {
        refinedDocs.push({
          documentType: (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
          fileStoreId: doc.fileStoreId,
          fileStore: doc.fileStoreId,
          fileName: "",
          dropDownValues: {
            value: (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
          },
        });
      });
    return refinedDocs;
  };

  const getQuestion = (data) => {
    let refinedQues = [];
    var i;
    for (i = 0; i < data?.questionLength; i++) {
      refinedQues.push({
        remarks: data[`Remarks_${i}`],
        question: data?.questionList[i].question,
        value: data?.[`question_${i}`]?.code,
      });
    }
    return refinedQues;
  };

  const getfeildInspection = (data) => {
    let formdata = [],
      inspectionOb = [];

    if (data?.additionalDetails?.fieldinspection_pending?.length > 0) {
      inspectionOb = data?.additionalDetails?.fieldinspection_pending;
    }

    if (data.status == "FIELDINSPECTION_INPROGRESS") {
      formdata = JSON.parse(sessionStorage.getItem("INSPECTION_DATA"));
      formdata?.length > 0 &&
        formdata.map((ob, ind) => {
          inspectionOb.push({
            docs: getInspectionDocs(ob.Documents),
            date: ob.InspectionDate,
            questions: getQuestion(ob),
            time: ob?.InspectionTime,
          });
        });
      inspectionOb = inspectionOb.filter((ob) => ob.docs && ob.docs.length > 0);
    } else {
      sessionStorage.removeItem("INSPECTION_DATA");
    }

    let fieldinspection_pending = [...inspectionOb];
    return fieldinspection_pending;
  };

  const getDocuments = () => {
    let documentsformdata = JSON.parse(sessionStorage.getItem("BPA_DOCUMENTS"));
    let documentList = [];
    documentsformdata?.map((doc) => {
      if (doc?.uploadedDocuments?.[0]?.values?.length > 0) documentList = [...documentList, ...doc?.uploadedDocuments?.[0]?.values];
      if (doc?.newUploadedDocs?.length > 0) documentList = [...documentList, ...doc?.newUploadedDocs];
    });
    return documentList;
  };

  const getPendingApprovals = () => {
    const approvals = Digit.SessionStorage.get("OBPS_APPROVAL_CHECKS");
    const newApprovals = Digit.SessionStorage.get("OBPS_NEW_APPROVALS");
    let result = approvals?.reduce((acc, approval) => (approval?.checked ? acc.push(approval?.label) && acc : acc), []);
    result = result?.concat(newApprovals !== null ? newApprovals.filter((ob) => ob.label !== "").map((approval) => approval?.label) : []);
    return result;
  };

  async function submit(data) {
    console.log("isNoNOC", isNoNoc);

    if (isNoNoc && !isLowRiskCase) {
      Modal("NOC required", "Please select at least one NOC.", "error");
      return;
    }
    if (currentAction?.action === "ISSUE_CERTIFICATE") {
      onActionSelect(currentAction);
      // setOnAddComments(developerRemarks)
    }
    if (developerRemarksValidation === "Valid remarks entered") {
      // let workflow = { action: currentAction, comments: developerRemarks, businessService, moduleName: moduleCode };
      const additionalDetails = {
        ...applicationData?.additionalDetails,
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals() || [],
      };
      const workflow = {
        action: currentAction?.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...applicationData,
        documents: formData?.documents,
        additionalDetails,
        workflow,
        nocDetails: { ...formData?.nocDetails, ...officerNocDetails },
        nocOtherDetails: reduxFormData.othersDetails,
        action: currentAction?.action,
        comment: developerRemarks,
        // approvalLetterId: structureCertificateId,
        // approvalLetterUrl: structureCertificateUrl,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      submitAction({
        LandUse: appData,
      });
      Modal(
        `Application ${t(currentAction?.action)}ed `,
        `Application <strong>(${formData?.applicationNo}) ${t(currentAction?.action)}ed </strong>Successfully!`,
        "success",
        "/digit-ui/employee"
      );
    } else {
      console.log("developerRemarksValidation", developerRemarksValidation);
    }
  }

  async function ownerSubmit() {
    if (currentAction?.action === "ISSUE_CERTIFICATE") {
      onActionSelect(currentAction);
    }
    const additionalDetails = {
      ...applicationData?.additionalDetails,
      fieldinspection_pending: getfeildInspection(applicationData),
      pendingapproval: getPendingApprovals() || [],
    };
    const workflow = {
      action: currentAction?.action,
      comment: developerRemarks,
      comments: developerRemarks,
      assignee: null,
      assignes: null,
      varificationDocuments: uploadedFile
        ? [
            {
              documentType: currentAction + " DOC",
              fileName: file?.name,
              fileStoreId: uploadedFile,
            },
          ]
        : null,
    };
    const appData = {
      ...applicationData,
      documents: formData?.documents,
      additionalDetails,
      checklist: selectChecklist,
      workflow,
      action: currentAction?.action,
      comment: developerRemarks,
      // approvalLetterId: structureCertificateId,
      // approvalLetterUrl: structureCertificateUrl,
      assignee: null,
      wfDocuments: uploadedFile
        ? [
            {
              documentType: currentAction + " DOC",
              fileName: file?.name,
              fileStoreId: uploadedFile,
            },
          ]
        : null,
    };
    const data = { ...appData };
    await updateOwnerCall.mutate(
      { ownerRegistration: data },
      {
        onSuccess: async (result) => {
          if (result?.ownerRegistration?.[0]?.applicationNo) {
            let action = "";
            if (currentAction?.action === "APPROVED") {
              action = "Approved";
            } else if (currentAction?.action === "REJECT") {
              action = "Rejected";
            } else if (currentAction?.action === "SENDBACK_TO_APPLICANT") {
              action = "Sent to Applicant";
            } else if (currentAction?.action === "FORWARD_TO_LA_OFFICER") {
              action = "Forwarded to LA Officer";
            } else if (currentAction?.action === "FORWARD_TO_PROVISIONAL_APPROVED") {
              action = "Provisionally Approved";
            } else if (currentAction?.action === "SENDBACK_TO_EXECUTIVE_ENGINEER") {
              action = "Sent to Executive Engineer";
            } else if (currentAction?.action === "APPROVE") {
              action = "Approved";
            }
            Modal(
              `Application ${t(action)}`,
              `Application <strong>(${formData?.applicationNo}) ${t(action)}</strong>Successfully!`,
              "success",
              "/digit-ui/employee"
            );
          }
        },
      }
    );
  }
  async function purchasableFarSubmit() {
    // if (currentAction?.action === "ISSUE_CERTIFICATE") {
    //   onActionSelect(currentAction);
    // }
    if (userRolesArray?.[0]?.code === "JE" && (farDetails.circleRate == 0 || farDetails.circleRate == null)) {
      Modal("Circle rate is required", "Please enter circle rate in the FAR details section.", "error");
      return;
    }
    const additionalDetails = {
      ...applicationData?.additionalDetails,
      // fieldinspection_pending: getfeildInspection(applicationData),
      // pendingapproval: getPendingApprovals() || [],
    };
    const workflow = {
      action: purchasableFarActions?.action,
      comment: remarksData
        ? `${developerRemarks} <b>The checklist has been edited and overridden by the ${userRolesArray?.[0]?.name}.<b>`
        : developerRemarks,
      comments: remarksData
        ? `${developerRemarks} <b>The checklist has been edited and overridden by the ${userRolesArray?.[0]?.name}.<b>`
        : developerRemarks,
      assignee: null,
      assignes: null,
      varificationDocuments: uploadedFile
        ? [
            {
              documentType: purchasableFarActions + " DOC",
              fileName: file?.name,
              fileStoreId: uploadedFile,
            },
          ]
        : null,
    };
    const appData = {
      ...applicationData,
      documents: updatedDocuments,
      additionalDetails,
      checklist: formData?.checklist,

      checklistReview: reviewedData,
      descriptionOfLand: {
        properties: [{ ...applicationData?.descriptionOfLand?.properties?.[0], baseFAR: farDetails.baseFar, circleRate: farDetails.circleRate }],
      },
      tenantId: "up",
      workflow,
      action: purchasableFarActions?.action,
      comment: remarksData
        ? `<br> ${developerRemarks} <b>The checklist has been edited and overridden by the ${userRolesArray?.[0]?.name}.<b>`
        : developerRemarks,
      // approvalLetterId: structureCertificateId,
      // approvalLetterUrl: structureCertificateUrl,
      assignee: null,
      wfDocuments: uploadedFile
        ? [
            {
              documentType: purchasableFarActions + " DOC",
              fileName: file?.name,
              fileStoreId: uploadedFile,
            },
          ]
        : null,
    };
    const data = { ...appData };
    await updatePurchasableFar.mutate(
      { PurchasableFAR: data },
      {
        onSuccess: async (result) => {
          if (result?.PurchasableFAR?.[0]?.applicationNo) {
            Modal(`Remarks Added`, `Remarks for <strong>${formData?.applicationNo}</strong> added successfully!`, "success", "/digit-ui/employee");
          }
        },
      }
    );
    console.log("payLoadFromFarSubmit", data);
  }
  async function approvalOfLetterSubmits() {
    console.log("isNoNOCApprovalLetter", isNoNoc);

    if (formData?.descriptionOfLand?.selectLandUse == "Conditional Permissible" && Object.keys(mandatoryCondition)?.length < 1) {
      Modal("Mandatory condition is required", "Please select mandatory condition from dropdown.", "error");
      return;
    }
    if (isNoNoc && !isLowRiskCase) {
      Modal("NOC required", "Please select at least one NOC.", "error");
      return;
    }
    let currentAction = "APPROVED";
    try {
      const additionalDetails = {
        ...applicationData?.additionalDetails,
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals() || [],
      };
      const workflow = {
        action: currentAction,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...applicationData,
        documents: formData?.documents,
        additionalDetails,
        workflow,
        nocDetails: { ...formData?.nocDetails, ...officerNocDetails },
        mandatoryCondition: mandatoryCondition,
        action: currentAction,
        comment: developerRemarks,
        // approvalLetterId: fileStoreId,
        // approvalLetterUrl: structureCertificateUrl,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const data = { ...appData };
      await updateApiCall.mutate(
        { LandUse: data },
        {
          onSuccess: async (result) => {
            if (result?.LandUse?.[0]?.applicationNo) {
              Swal.fire({
                title: "Action Approved",
                text: `Application (${result?.LandUse?.[0]?.applicationNo}) Approved Successfully!`,
                icon: "success",
              }).then(() => {
                window.location.reload();
              });
            }
          },
        }
      );
      console.log("loggingupdatePayloadLandUSe", data);
    } catch (error) {
      console.log(error);
    }
  }

  const viewApprovalLetter = (url) => {
    window.open(url, "_blank");
    // Modal(
    //   `Application ${formData?.action} .`,
    //   `Application <strong>(${formData?.applicationNo}) ${t(formData?.action)} </strong> Submitted Successfully!`,
    //   "success",
    //   "/digit-ui/employee"
    // );
  };

  function onActionSelectIssue(data) {
    if (currentAction?.action === "ISSUE_CERTIFICATE") {
      // let workflow = { action: currentAction, comments: developerRemarks, businessService, moduleName: moduleCode };
      const additionalDetails = {
        ...applicationData?.additionalDetails,
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals() || [],
      };
      const workflow = {
        action: currentAction?.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...applicationData,
        documents: formData?.documents,
        additionalDetails,
        workflow,
        action: currentAction?.action,
        comment: developerRemarks,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      submitAction({
        LandUse: appData,
      });
    }
  }
  async function handleChangePayment() {
    if (actions?.[0]?.action === "MAKE_PAYMENT") {
      const additionalDetails = {
        ...applicationData?.additionalDetails,
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals() || [],
      };
      const workflow = {
        action: "MAKE_PAYMENT",
        comment: "Payment Done",
        comments: "Payment Done",
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: actions + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...applicationData,
        documents: formData?.documents,
        additionalDetails,
        workflow,
        action: "MAKE_PAYMENT",
        comments: "Payment Done",
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: actions + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      Digit.OBPSService.updateFormLandUse({ LandUse: appData }, tenantId).then((result) => {
        if (result?.LandUse?.length > 0) {
          console.log("resultFromLandUseUpdate", result);

          // setShowToast({
          //   key: "true",
          //   error: false,
          //   message: `Application (${result?.LandUse?.[0]?.applicationNo}) Updated Successfully!`,
          // });
          // history.push(
          //   `${citizenBaseUrl}/payment/collect/${result?.LandUse?.[0]?.businessService}/${result?.LandUse?.[0]?.applicationNo}/${tenantId}/tenantId=${tenantId}`
          // );
          setShowToast({
            key: "true",
            error: false,
            message: `Application Updated Successfully! Redirecting to the payment page...`,
          });
          //   `${citizenBaseUrl}/payment/collect/${result?.LandUse?.[0]?.businessService}/${result?.LandUse?.[0]?.applicationNo}/${tenantId}/tenantId=${tenantId}`
          window.location.assign(
            `${citizenBaseUrl}/payment/collect/BPA.LAND_USE_FORM/${result?.LandUse?.[0]?.applicationNo}/${tenantId}/tenantId=${tenantId}`
          );
        }
      });
    }
    if (actions?.[0]?.action === "MAKE_PAYMENT_APPLICATION_FEE") {
      try {
        const additionalDetails = {
          ...applicationData?.additionalDetails,
          fieldinspection_pending: getfeildInspection(applicationData),
          pendingapproval: getPendingApprovals() || [],
        };
        const workflow = {
          action: "MAKE_PAYMENT_APPLICATION_FEE",
          comment: "Payment Done",
          comments: "Payment Done",
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        const appData = {
          ...applicationData,
          documents: formData?.documents,
          additionalDetails,
          workflow,
          action: "MAKE_PAYMENT_APPLICATION_FEE",
          comments: "Payment Done",
          assignee: null,
          wfDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        /////
        console.log("appData2222222222", appData);
        Digit.OBPSService.updateFormLandUse({ LandUse: appData }, tenantId).then((result) => {
          if (result?.LandUse?.length > 0) {
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result?.LandUse?.[0]?.applicationNo}) Updated Successfully!`,
            });
            history.replace(
              `${citizenBaseUrl}/payment/collect/${params?.businessService}/${params?.applicationNo}/${tenantId}/tenantId=${tenantId}`,
              { data: params }
            );
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }

  async function handleChangePaymentDone() {
    if (actions?.[1]?.action === "PAYMENT_DONE") {
      const additionalDetails = {
        ...applicationData?.additionalDetails,
      };
      const workflow = {
        action: "PAYMENT_DONE",
        comment: remarksData ? `${developerRemarks} <b>The checklist has been edited and overridden by the employee.<b>` : developerRemarks,
        comments: remarksData ? `${developerRemarks} <b>The checklist has been edited and overridden by the employee.<b>` : developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: action + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...applicationData,
        documents: formData?.documents,
        additionalDetails,
        checklist: formData?.checklist,

        checklistReview: reviewedData,
        descriptionOfLand: {
          properties: [{ ...applicationData?.descriptionOfLand?.properties?.[0], baseFAR: farDetails.baseFar, circleRate: farDetails.circleRate }],
        },
        tenantId: "up",
        workflow,
        action: "PAYMENT_DONE",
        comment: remarksData
          ? `<br> ${developerRemarks} <b>The checklist has been edited and overridden by the ${userRolesArray?.name}.<b>`
          : developerRemarks,
        // approvalLetterId: structureCertificateId,
        // approvalLetterUrl: structureCertificateUrl,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: action + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const data = { ...appData };
      await updatePurchasableFar.mutate(
        { PurchasableFAR: data },
        {
          onSuccess: async (result) => {
            if (result?.PurchasableFAR?.[0]?.applicationNo) {
              Modal(
                `Payment Done`,
                `Payment for <strong>${formData?.applicationNo}</strong> done successfully!`,
                "success",
                `/digit-ui/citizen/profile`
              );
            }
          },
        }
      );
    }
  }

  const approvalOfLetterPdf = async (currentAction) => {
    if (currentAction?.action === "APPROVED" && signatureAccess) {
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01",
          authToken: authToken,
          userInfo: userInfo,
        },
      };

      try {
        // Send the request to the API to get the fileStore details
        const response = await axios.post(`${Urls.obps.designOfApproval}?tenantId=up&applicationNumber=${formData?.applicationNo}`, dataToSend);

        const { fileStoreId, fileStoreUrl } = response.data;

        // Set the certificate ID and URL
        setStructureCertificateId(fileStoreId);
        setStructureCertificateUrl(fileStoreUrl);

        // Show take action

        // Open the generated file in a new window
        window.open(fileStoreUrl);

        // Pass the fileStoreId to another function to handle submission
        await approvalOfLetterSubmits(fileStoreId);
      } catch (error) {
        // Log the error to understand what went wrong
        console.error("Error while generating the approval letter PDF: ", error);
      }
    } else {
      setStructureCertificateError("Please Upload Your Signature");
    }
  };

  const structuralStabilityPdf = async (currentAction) => {
    console.log("enter111111111", stateId, formData?.applicationNo);

    if (currentAction?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && signatureAccess) {
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01",
          authToken: authToken,
          userInfo: userInfo,
        },
      };
      try {
        const Resp = await axios.post(`${Urls.obps.designOfStuctural}?tenantId=hp&applicationNumber=${id}`, dataToSend).then((response) => {
          return response.data;
        });

        console.log("Response From API", Resp);
        setStructureCertificateId(Resp?.fileStoreId);
        setStructureCertificateUrl(Resp?.fileStoreUrl);
        setShowTakeAction("Take_Action");
        window.open(Resp?.fileStoreUrl);
        // setRemarksData(Resp);
      } catch (error) {
        console.log(error);
      }
    } else {
      setStructureCertificateError("Please Upload your signature");
    }
  };

  function structuralStabilitySubmit() {
    if (currentAction?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && signatureAccess) {
      const additionalDetails = { ...applicationData?.additionalDetails, fieldinspection_pending: getfeildInspection(applicationData) };
      const workflow = {
        action: currentAction?.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...applicationData,
        documents: formData?.documents,
        additionalDetails,
        workflow,
        structureCertificateUrl: structureCertificateUrl,
        structureCertificateId: structureCertificateId,
        action: currentAction?.action,
        comment: developerRemarks,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      submitAction({
        LandUse: appData,
      });
    } else {
      setStructureCertificateError("Please Upload your signature");
    }
  }

  function handleChangeForward() {
    if (actions?.[0]?.action === "FORWARD_TO_DEPARTMENT") {
      try {
        const additionalDetails = {
          ...applicationData?.additionalDetails,
          fieldinspection_pending: getfeildInspection(applicationData),
          pendingapproval: getPendingApprovals() || [],
        };
        const workflow = {
          action: "FORWARD_TO_DEPARTMENT",
          comment: developerRemarks,
          comments: developerRemarks,
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        const appData = {
          ...applicationData,
          documents: formData?.documents,
          additionalDetails,
          workflow,
          action: "FORWARD_TO_DEPARTMENT",
          comment: developerRemarks,
          assignee: null,
          wfDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        /////
        console.log("appData2222222222", appData);
        Digit.OBPSService.updateFormLandUse({ LandUse: appData }, tenantId).then((result) => {
          if (result?.LandUse?.length > 0) {
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result?.LandUse?.[0]?.applicationNo}) Updated Successfully!`,
            });
            // window.location.assign(`${window.location.origin}/digit-ui/citizen/payment/collect/${`bpa/${result?.LandUse?.[0]?.applicationNo}/${tenantId}?tenantId=${tenantId}?flow=${result?.LandUse?.[0]?.applicationType}`}`);
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }

  const handleChangedata = (e) => {
    // setLoader(false);
    setCurrentActionCertification("showActionCertification");
    onActionSelect(currentAction?.action);
  };

  const handleFormDataUpdate = (data) => {
    console.log("Form data updated:", data);
    setFormDataNoc(data);
  };
  // useEffect(() => {
  //   if (["APPROVED", "APPROVE"].includes(currentAction?.action)) {
  //     setOpen(true);
  //   }
  // }, [currentAction]);
  const handleClose = () => {
    // setOpen(false);
  };

  const designationName = workflowDetails?.data?.timeline?.[0]?.assigner?.roles?.find((ele) => ele?.code !== "EMPLOYEE")?.name;
  if (pdfLoading) {
    return <Loader />;
  }
  console.log("tabListFromForm", tablist);
  return (
    <React.Fragment>
      <Tabs value={currentTab} onChange={handleChange}>
        {tablist.map(({ label, color }, index) => (
          <Tab label={`${t(label)}`} value={`${index}`} sx={{ textTransform: "none", p: "0 1rem", color }} />
        ))}
      </Tabs>
      {isPurchasableFAR && user?.info?.type !== "CITIZEN" && (
        <StyledTabPanel value={currentTab} index="0">
          <Summary id={formData?.applicationNo} />
        </StyledTabPanel>
      )}
      {isPurchasableFAR && user?.info?.type !== "CITIZEN" && (
        <StyledTabPanel value={currentTab} index="1">
          <DocumentSection
            formData={formData}
            setUpdatedDocuments={setUpdatedDocuments}
            updatedDocuments={updatedDocuments}
            handleChange={handleChange}
            isCitizen={user?.info?.type === "CITIZEN"}
          />
          {/* <DocumentViewer /> */}
        </StyledTabPanel>
      )}

      <StyledTabPanel
        value={currentTab}
        index={user?.info?.type === "CITIZEN" ? "0" : !isPurchasableFAR && user?.info?.type === "EMPLOYEE" ? "0" : "2"}
        style={{ marginBottom: "30px" }}
      >
        {user?.info?.type === "EMPLOYEE" && <CollapsibleHistory formData={formData} />}

        {user?.info?.type === "EMPLOYEE" && (
          <React.Fragment>
            <EmployeeComponent formData={formData} applicationDocs={applicationDocs} totalAmount={totalAmount} />
            {isLandUse && formData?.status != "APPROVED" && (
              <Card style={{ color: "red" }}>
                <div style={{ marginTop: "10px" }}>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={checked} onChange={handleChangeCheckBox} inputProps={{ "aria-label": "controlled" }} />}
                      label="I, hereby, certify that all the information filled the Application Form by Applicant, has been checked and verified by me and the NOC checklist mentioned above are complete as per the applicable rules and Bylaws."
                    />
                  </FormGroup>
                </div>

                {checked === false && <p>Please review the NOC checklist and select the applicable items to complete the form verification.</p>}
              </Card>
            )}
          </React.Fragment>
        )}
        {userRoles.includes("BPA_STRUCTURALENGINEER") &&
          user?.info?.type === "CITIZEN" &&
          workflowDetails?.data?.nextActions?.[0]?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && (
            <Structural formData={formData} applicationDocs={applicationDocs} totalAmount={totalAmount} />
          )}

        {(userRoles.includes("BPA_ARCHITECT") ||
          userRoles.includes("BPA_TOWNPLANNER") ||
          userRoles.includes("BPA_ENGINEER") ||
          userRoles.includes("BPA_ARCHITECT_ASSISTANT") ||
          userRoles.includes("BPA_ENGINEER_DIPLOMA") ||
          userRoles.includes("BPA_DRAUGHTSMAN") ||
          userRoles.includes("BPA_SURVEYOR")) &&
          user?.info?.type === "CITIZEN" &&
          workflowDetails?.data?.nextActions?.[0]?.action != "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && (
            <Architect formData={formData} applicationDocs={applicationDocs} totalAmount={totalAmount} actions={actions} />
          )}

        {formData?.applicationType != "FORM_PURCHASABLE_FAR" && (
          <React.Fragment>
            <div style={{ padding: "10px" }}>
              <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                {/* {isLandUse &&
                  user?.info?.type === "EMPLOYEE" &&
                  formData?.descriptionOfLand?.selectLandUse == "Conditional Permissible" &&
                  !(formData?.status === "APPROVED" || showTakeAction === "Take_Action") && (
                    // <SelectMandatoryConditions setMandatoryCondition={setMandatoryCondition} />
                    <SelectMandatoryConditions2 setMandatoryCondition={setMandatoryCondition} />
                  )} */}
                {((userRoles.includes("BPA_STRUCTURALENGINEER") &&
                  workflowDetails?.data?.nextActions?.[0]?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE") ||
                  user?.info?.type === "EMPLOYEE") && (
                  <>
                    <Box gridColumn="span 2">
                      <b>Action </b>
                    </Box>
                    <Box gridColumn="span 10">
                      <RadioButtons
                        isMandatory={false}
                        options={actions}
                        selectedOption={currentAction || purchasableFarActions}
                        optionsKey="action"
                        onSelect={onRadioActionSelect}
                        style={{ display: "flex", gap: "3rem", margin: 0 }}
                        // isDependent={true}
                      />
                    </Box>
                  </>
                )}
                {currentAction != null && currentAction?.action != "APPROVED" && (
                  <>
                    <Box gridColumn="span 2">
                      <b>Remark </b>
                    </Box>
                    <Box gridColumn="span 10">
                      <DemoParinted setContent={setDeveloperRemarks} content={developerRemarks}></DemoParinted>
                    </Box>
                  </>
                )}
                {currentAction?.action == "APPROVED" && (isApprovedOwnerReg || isOwnerReg) && (
                  <>
                    <Box gridColumn="span 2">
                      <b>Remark </b>
                    </Box>
                    <Box gridColumn="span 10">
                      <DemoParinted setContent={setDeveloperRemarks} content={developerRemarks}></DemoParinted>
                    </Box>
                  </>
                )}
                {/* Purchasable Far actions */}
                {[
                  "ADD_REMARK",
                  "ADD_REMARK_EE",
                  "ADD_REMARK_SAP",
                  "FORWARD",
                  "REJECTED",
                  "REVERT_TO_APPLICANT",
                  "FORWARD_TO_OWNER_FOR_PAYMENT",
                  "REVERT_TO_CTP",
                ].includes(purchasableFarActions?.action) &&
                  isPurchasableFAR && (
                    <>
                      <Box gridColumn="span 2">
                        <b>Remark</b>
                      </Box>
                      <Box gridColumn="span 10">
                        <DemoParinted setContent={setDeveloperRemarks} content={developerRemarks}></DemoParinted>
                      </Box>
                    </>
                  )}
              </Box>

              {/* as per discussion remove upload documents  */}
              <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                <Box gridColumn="span 2"> Document /Certificate</Box>
                <Box gridColumn="span 10">
                  <UploadFile
                    id={"workflow-doc"}
                    onUpload={selectFile}
                    onDelete={() => {
                      setUploadedFile(null);
                    }}
                    message={uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`)}
                    accept="image/*, .pdf, .png, .jpeg, .jpg"
                    iserror={error}
                  />
                </Box>
              </Box>
              <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                  sx: {
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                    padding: "16px",
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    color: "white",
                    background: "linear-gradient(90deg, rgb(14, 118, 147), rgba(0, 176, 255, 1))", // Gradient from teal to blue
                    padding: "12px 16px",
                    borderRadius: "8px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <img
                    src="https://i.imgur.com/CNqKZu3.jpeg"
                    alt="Disclaimer icon"
                    style={{
                      width: "70px",
                      height: "30px",
                      borderRadius: "50%",
                    }}
                  />
                  Disclaimer<span className="compulsoryField">*</span>
                </DialogTitle>

                <DialogContent>
                  <DialogContentText
                    sx={{
                      color: "black",
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                      padding: "8px 0",
                      marginTop: "10px",
                    }}
                  >
                    {currentAction?.action === "APPROVED" ? "All the details and documents are ok. Approved." : "Payment has been verified."}
                    {currentAction?.action === "APPROVE" ? "All the details and documents are ok. Approved." : "Payment has been verified."}
                  </DialogContentText>
                </DialogContent>

                <DialogActions>
                  <Button
                    onClick={handleClose}
                    sx={{
                      backgroundColor: "rgb(14, 118, 147)",
                      color: "#fff",
                      fontWeight: "bold",
                      padding: "8px 16px",
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "#0e7693",
                      },
                    }}
                  >
                    Accept
                  </Button>
                </DialogActions>
              </Dialog>

              {/*  */}
              {((userRoles.includes("BPA_STRUCTURALENGINEER") &&
                workflowDetails?.data?.nextActions?.[0]?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE") ||
                user?.info?.type === "EMPLOYEE") && (
                <>
                  <Card style={{ marginTop: "15px" }}>
                    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                      <Box gridColumn="span 3">
                        {(formData?.status === "APPROVED" || showTakeAction === "Take_Action") && (
                          <Button
                            variant="contained"
                            style={{ marginLeft: "10px", background: "#e08d0e" }}
                            onClick={() => viewApprovalLetter(formData?.approvalLetterUrl)}
                          >
                            Approval Letter <DownloadIcon />
                          </Button>
                        )}
                        {/* </div> */}
                      </Box>
                      <Box gridColumn="span 7">
                        {currentAction?.action === "APPROVED" && checked === true && (
                          <Button
                            variant="contained"
                            color="success"
                            style={{ marginLeft: "10px", fontSize: "12px" }}
                            // onClick={() => approvalOfLetterPdf(currentAction)}
                            onClick={() => approvalOfLetterSubmits()}
                          >
                            {t("BUTTON_EMP_SUBMITFORM")}
                          </Button>
                        )}
                        {/* OWNER  For APPROVED */}
                        {currentAction?.action === "APPROVED" && appType === "FORM_OWNER_REGISTRATION" && (
                          <Button
                            variant="contained"
                            color="success"
                            style={{ marginLeft: "10px", fontSize: "12px" }}
                            onClick={() => ownerSubmit(currentAction)}
                          >
                            {t("BUTTON_EMP_SUBMITFORM")}
                          </Button>
                        )}
                        {currentAction?.action === "REVERT_WITH_OBSERVATION" && developerRemarksValidation === "Valid remarks entered" && (
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                            {t("BUTTON_EMP_SUBMITFORM")}
                          </Button>
                        )}
                        {["REVERT_TO_JE", "REVERT_TO_AE", "REVERT_TO_EE_TP", "REVERT_TO_CTP", "REVERT_TO_ADDITIONAL_SECRETORY"].includes(
                          currentAction?.action
                        ) &&
                          developerRemarksValidation === "Valid remarks entered" && (
                            <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                              {t("BUTTON_EMP_SUBMITFORM")}
                            </Button>
                          )}
                        {currentAction?.action === "REJECTED" && developerRemarksValidation === "Valid remarks entered" && (
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                            {t("BUTTON_EMP_SUBMITFORM")}
                          </Button>
                        )}
                        {currentAction?.action === "UNDERPROCESS" && developerRemarksValidation === "Valid remarks entered" && (
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                            {t("BUTTON_EMP_SUBMITFORM")}
                          </Button>
                        )}
                        {currentAction?.action === "FORWARD" && developerRemarksValidation === "Valid remarks entered" && (
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                            {/* Submit  */}
                            {t("BUTTON_EMP_SUBMITFORM")}
                          </Button>
                        )}
                        {["FORWARD_TO_LA_OFFICER", "REJECT", "SENDBACK_TO_APPLICANT", "FORWARD_TO_PROVISIONAL_APPROVED"].includes(
                          currentAction?.action
                        ) && (
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={ownerSubmit}>
                            {t("BUTTON_EMP_SUBMITFORM")}
                          </Button>
                        )}
                        {currentAction?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && (
                          <Button
                            variant="contained"
                            color="success"
                            style={{ marginLeft: "10px" }}
                            onClick={() => structuralStabilityPdf(currentAction)}
                          >
                            View Structural Stability Certificate
                            <FileDownloadIcon />
                          </Button>
                        )}
                        {currentAction?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && showTakeAction === "Take_Action" && (
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={structuralStabilitySubmit}>
                            {/* Forward */}
                            {t("BUTTON_CITIZEN_FORWARD")}
                          </Button>
                        )}
                        {currentAction?.action === "REVERT_TO_APPLICANT" && developerRemarksValidation === "Valid remarks entered" && (
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                            {/* Revert */}
                            {t("BUTTON_EMP_REVERT_TO_APPLICANT")}
                          </Button>
                        )}
                        {/* PurchasableFAR Submit button logic below */}
                        {isPurchasableFAR && developerRemarksValidation === "Valid remarks entered" && (
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={purchasableFarSubmit}>
                            {t("BUTTON_EMP_SUBMITFORM")}
                          </Button>
                        )}
                      </Box>
                    </Box>
                  </Card>
                </>
              )}
            </div>
            {(userRoles.includes("BPA_ARCHITECT") ||
              userRoles.includes("BPA_TOWNPLANNER") ||
              userRoles.includes("BPA_ENGINEER") ||
              userRoles.includes("BPA_ARCHITECT_ASSISTANT") ||
              userRoles.includes("BPA_ENGINEER_DIPLOMA") ||
              userRoles.includes("BPA_DRAUGHTSMAN") ||
              userRoles.includes("BPA_SURVEYOR")) &&
              user?.info?.type === "CITIZEN" && (
                <React.Fragment>
                  {actions?.[0]?.action === "MAKE_PAYMENT" && (
                    <div style={{ marginTop: "15px" }}>
                      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                        <Box gridColumn="span 2"></Box>
                        <Box gridColumn="span 8"></Box>
                        <Box gridColumn="span 2">
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangePayment}>
                            Payment
                          </Button>
                        </Box>
                      </Box>
                    </div>
                  )}

                  {/* {actions?.[0]?.action === "MAKE_PAYMENT_APPLICATION_FEE" && (
                    <div style={{ marginTop: "15px" }}>
                      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                        <Box gridColumn="span 2"></Box>
                        <Box gridColumn="span 8"></Box>
                        <Box gridColumn="span 2">
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangePayment}>
                            Payment
                          </Button>
                        </Box>
                      </Box>
                    </div>
                  )} */}

                  {actions?.[0]?.action === "FORWARD_TO_DEPARTMENT" && (
                    <div style={{ marginTop: "15px" }}>
                      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                        <Box gridColumn="span 2"></Box>
                        <Box gridColumn="span 6"></Box>
                        <Box gridColumn="span 4">
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangeForward}>
                            Forward To Department
                          </Button>
                        </Box>
                      </Box>
                    </div>
                  )}
                </React.Fragment>
              )}
          </React.Fragment>
        )}
        {/* --------------------------------------------------only for demo after demo changes by Akash --------------------------------*/}
        {formData?.applicationType === "FORM_PURCHASABLE_FAR" && user?.info?.type === "EMPLOYEE" && (
          <div>
            <div className="row" style={{ marginTop: "10px", marginRight: "30px" }}>
              <Card>
                <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                  {((userRoles.includes("BPA_STRUCTURALENGINEER") &&
                    workflowDetails?.data?.nextActions?.[0]?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE") ||
                    user?.info?.type === "EMPLOYEE") && (
                    <>
                      <Box gridColumn="span 2">
                        <b style={{ marginRight: "2px" }}>Action </b>
                      </Box>

                      <Box gridColumn="span 10" style={{ display: "flex" }}>
                        {/* <RadioButtons
                          isMandatory={false}
                          options={actions}
                          selectedOption={currentAction || purchasableFarActions}
                          optionsKey="action"
                          onSelect={onRadioActionSelect}
                          // style={{ display: "flex", gap: "1rem", margin: 0 }}
                          style={{ display: "flex", flexWrap: "wrap", margin: 0 }}
                        /> */}
                        {/* <Dropdown
                                isMandatory={true}
                                selected={currentAction || purchasableFarActions}
                                select={onRadioActionSelect}
                                option={actions}
                                placeholder="Select Action"
                                optionKey="action"
                            
                              /> */}
                        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                          <Select
                            // displayEmpty
                            value={currentAction || purchasableFarActions}
                            label="Select Action"
                            onChange={onDropDownSelect}
                            // autoWidth={autoWidth}
                            sx={{ width: "18.25vw", borderRadius: "1px" }}
                            size="small"
                            variant="outlined"
                            required={false}
                            input={<OutlinedInput />}
                            renderValue={(selected) => {
                              if (selected && selected.length === 0) {
                                return <em>Select Action</em>;
                              }
                              return selected.action;
                            }}
                            // MenuProps={MenuProps}
                            // inputProps={{ "aria-label": "Without label" }}
                          >
                            <StyledMenuItem disabled value="" key="Select Action">
                              <em>Select Action</em>
                            </StyledMenuItem>
                            {actions &&
                              actions?.map((item) => {
                                const dropdowns = item?.action;
                                return (
                                  <StyledMenuItem
                                    value={item}
                                    key={dropdowns}
                                    // className={width && "customWidth"}
                                  >
                                    {dropdowns}
                                  </StyledMenuItem>
                                );
                              })}
                          </Select>
                        </FormControl>
                      </Box>
                    </>
                  )}
                </Box>
              </Card>
            </div>

            <div className="row" style={{ marginTop: "10px", marginRight: "30px" }}>
              {/* {formData?.applicationType === "FORM_PURCHASABLE_FAR" && (
                <Card
                  style={{ textAlign: "center", marginBottom: "5px", padding: "-8px", backgroundColor: "rgb(255, 217, 84)", marginRight: "30px" }}
                >
                  {" "}
                  Remarks History
                </Card>
              )} */}
              {currentAction?.action ||
                (purchasableFarActions?.action && (
                  <Card style={{ backgroundColor: "#F7F7F7" }}>
                    <div style={{ padding: "10px" }}>
                      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                        {currentAction != null && currentAction?.action != "APPROVED" && (
                          <>
                            <Box gridColumn="span 2">
                              <b style={{ marginRight: "2px" }}>Remarks </b>
                            </Box>
                            <Box gridColumn="span 10">
                              <DemoParinted setContent={setDeveloperRemarks} content={developerRemarks}></DemoParinted>
                            </Box>
                          </>
                        )}
                        {currentAction?.action == "APPROVED" && (isApprovedOwnerReg || isOwnerReg) && (
                          <>
                            <Box gridColumn="span 2">
                              <b style={{ marginRight: "2px" }}>Remarks </b>
                            </Box>
                            <Box gridColumn="span 10">
                              <DemoParinted setContent={setDeveloperRemarks} content={developerRemarks}></DemoParinted>
                            </Box>
                          </>
                        )}
                        {!["APPROVED"].includes(purchasableFarActions?.action) && isPurchasableFAR && (
                          <>
                            <Box gridColumn="span 2">
                              <b style={{ marginRight: "2px" }}>Remarks </b>
                            </Box>
                            <Box gridColumn="span 12">
                              <DemoParinted setContent={setDeveloperRemarks} content={developerRemarks}></DemoParinted>
                            </Box>
                          </>
                        )}
                      </Box>
                      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                        <Box gridColumn="span 2">
                          <b style={{ marginRight: "2px" }}>Document </b>
                        </Box>
                        <Box gridColumn="span 10">
                          <UploadFile
                            id={"workflow-doc"}
                            onUpload={selectFile}
                            onDelete={() => {
                              setUploadedFile(null);
                            }}
                            message={uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`)}
                            accept="image/*, .pdf, .png, .jpeg, .jpg"
                            iserror={error}
                          />
                        </Box>
                      </Box>

                      <Dialog
                        open={open}
                        onClose={handleClose}
                        PaperProps={{
                          sx: {
                            borderRadius: "12px",
                            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                            padding: "16px",
                          },
                        }}
                      >
                        <DialogTitle
                          sx={{
                            color: "white",
                            background: "linear-gradient(90deg, rgb(14, 118, 147), rgba(0, 176, 255, 1))", // Gradient from teal to blue
                            padding: "12px 16px",
                            borderRadius: "8px",
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <img
                            src="https://i.imgur.com/CNqKZu3.jpeg"
                            alt="Disclaimer icon"
                            style={{
                              width: "70px",
                              height: "30px",
                              borderRadius: "50%",
                            }}
                          />
                          Disclaimer<span className="compulsoryField">*</span>
                        </DialogTitle>

                        <DialogContent>
                          <DialogContentText
                            sx={{
                              color: "black",
                              fontWeight: "bold",
                              fontSize: "1.1rem",
                              padding: "8px 0",
                              marginTop: "10px",
                            }}
                          >
                            {currentAction?.action === "APPROVED" ? "All the details and documents are ok. Approved." : "Payment has been verified."}
                            {currentAction?.action === "APPROVE" ? "All the details and documents are ok. Approved." : "Payment has been verified."}
                          </DialogContentText>
                        </DialogContent>

                        <DialogActions>
                          <Button
                            onClick={handleClose}
                            sx={{
                              backgroundColor: "rgb(14, 118, 147)",
                              color: "#fff",
                              fontWeight: "bold",
                              padding: "8px 16px",
                              borderRadius: "8px",
                              "&:hover": {
                                backgroundColor: "#0e7693",
                              },
                            }}
                          >
                            Accept
                          </Button>
                        </DialogActions>
                      </Dialog>

                      {((userRoles.includes("BPA_STRUCTURALENGINEER") &&
                        workflowDetails?.data?.nextActions?.[0]?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE") ||
                        user?.info?.type === "EMPLOYEE") && (
                        <>
                          <div style={{ marginTop: "15px" }}>
                            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                              <Box gridColumn="span 3">
                                {(formData?.status === "APPROVED" || showTakeAction === "Take_Action") && (
                                  <Button
                                    variant="contained"
                                    style={{ marginLeft: "10px", background: "#e08d0e" }}
                                    onClick={() => viewApprovalLetter(formData?.approvalLetterUrl)}
                                  >
                                    Approval Letter <DownloadIcon />
                                  </Button>
                                )}
                              </Box>
                              <Box gridColumn="span 7">
                                {currentAction?.action === "APPROVED" && checked === true && (
                                  <Button
                                    variant="contained"
                                    color="success"
                                    style={{ marginLeft: "10px", fontSize: "12px" }}
                                    // onClick={() => approvalOfLetterPdf(currentAction)}
                                    onClick={() => approvalOfLetterSubmits()}
                                  >
                                    {t("BUTTON_EMP_SUBMITFORM")}
                                  </Button>
                                )}
                                {isPurchasableFAR && purchasableFarActions?.action === "APPROVED" && (
                                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={purchasableFarSubmit}>
                                    {t("BUTTON_EMP_SUBMITFORM")}
                                  </Button>
                                )}

                                {currentAction?.action === "REVERT_WITH_OBSERVATION" && developerRemarksValidation === "Valid remarks entered" && (
                                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                                    {t("BUTTON_EMP_SUBMITFORM")}
                                  </Button>
                                )}
                                {["REVERT_TO_JE", "REVERT_TO_AE", "REVERT_TO_EE_TP", "REVERT_TO_CTP", "REVERT_TO_ADDITIONAL_SECRETORY"].includes(
                                  currentAction?.action
                                ) &&
                                  developerRemarksValidation === "Valid remarks entered" && (
                                    <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                                      {t("BUTTON_EMP_SUBMITFORM")}
                                    </Button>
                                  )}
                                {currentAction?.action === "REJECTED" && developerRemarksValidation === "Valid remarks entered" && (
                                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                                    {t("BUTTON_EMP_SUBMITFORM")}
                                  </Button>
                                )}
                                {currentAction?.action === "UNDERPROCESS" && developerRemarksValidation === "Valid remarks entered" && (
                                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                                    {t("BUTTON_EMP_SUBMITFORM")}
                                  </Button>
                                )}
                                {currentAction?.action === "FORWARD" && developerRemarksValidation === "Valid remarks entered" && (
                                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                                    {/* Submit  */}
                                    {t("BUTTON_EMP_SUBMITFORM")}
                                  </Button>
                                )}
                                {["FORWARD_TO_LA_OFFICER", "REJECT", "SENDBACK_TO_APPLICANT", "FORWARD_TO_PROVISIONAL_APPROVED"].includes(
                                  currentAction?.action
                                ) && (
                                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={ownerSubmit}>
                                    {t("BUTTON_EMP_SUBMITFORM")}
                                  </Button>
                                )}
                                {(currentAction?.action === "APPROVED" || currentAction?.action === "APPROVE") && (
                                  <Button
                                    variant="contained"
                                    color="success"
                                    style={{ marginLeft: "10px", fontSize: "12px" }}
                                    onClick={() => ownerSubmit(currentAction)}
                                  >
                                    {t("BUTTON_EMP_SUBMITFORM")}
                                  </Button>
                                )}
                                {/* <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submitForm}>Submit</Button> */}
                                {currentAction?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && (
                                  <Button
                                    variant="contained"
                                    color="success"
                                    style={{ marginLeft: "10px" }}
                                    onClick={() => structuralStabilityPdf(currentAction)}
                                  >
                                    View Structural Stability Certificate
                                    <FileDownloadIcon />
                                  </Button>
                                )}
                                {currentAction?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && showTakeAction === "Take_Action" && (
                                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={structuralStabilitySubmit}>
                                    {/* Forward */}
                                    {t("BUTTON_CITIZEN_FORWARD")}
                                  </Button>
                                )}
                                {currentAction?.action === "REVERT_TO_APPLICANT" && developerRemarksValidation === "Valid remarks entered" && (
                                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                                    {/* Revert */}
                                    {t("BUTTON_EMP_REVERT_TO_APPLICANT")}
                                  </Button>
                                )}
                                {/* PurchasableFAR Submit button logic below */}
                                {isPurchasableFAR && developerRemarksValidation === "Valid remarks entered" && (
                                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={purchasableFarSubmit}>
                                    {t("BUTTON_EMP_SUBMITFORM")}
                                  </Button>
                                )}
                              </Box>
                            </Box>
                          </div>
                        </>
                      )}
                    </div>
                  </Card>
                ))}
            </div>
          </div>
        )}

        {formData?.applicationType === "FORM_PURCHASABLE_FAR" &&
          (userRoles.includes("BPA_ARCHITECT") ||
            userRoles.includes("BPA_TOWNPLANNER") ||
            userRoles.includes("BPA_ENGINEER") ||
            userRoles.includes("BPA_ARCHITECT_ASSISTANT") ||
            userRoles.includes("BPA_ENGINEER_DIPLOMA") ||
            userRoles.includes("BPA_DRAUGHTSMAN") ||
            userRoles.includes("BPA_SURVEYOR")) &&
          user?.info?.type === "CITIZEN" && (
            <React.Fragment>
              {/* {actions?.[0]?.action === "MAKE_PAYMENT" && (
                <div style={{ marginTop: "15px" }}>
                  <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                    <Box gridColumn="span 2"></Box>
                    <Box gridColumn="span 8"></Box>
                    <Box gridColumn="span 2">
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangePayment}>
                        Hurrah!
                      </Button>
                    </Box>
                  </Box>
                </div>
              )} */}

              {actions?.[0]?.action === "MAKE_PAYMENT_APPLICATION_FEE" && (
                <div style={{ marginTop: "15px" }}>
                  <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                    <Box gridColumn="span 2"></Box>
                    <Box gridColumn="span 8"></Box>
                    <Box gridColumn="span 2">
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangePayment}>
                        Payment
                      </Button>
                    </Box>
                  </Box>
                </div>
              )}

              {actions?.[0]?.action === "FORWARD_TO_DEPARTMENT" && (
                <div style={{ marginTop: "15px" }}>
                  <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                    <Box gridColumn="span 2"></Box>
                    <Box gridColumn="span 6"></Box>
                    <Box gridColumn="span 4">
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangeForward}>
                        Forward To Department
                      </Button>
                    </Box>
                  </Box>
                </div>
              )}
            </React.Fragment>
          )}
        <div style={{ color: "red" }}>
          <marquee> {structureCertificateError}</marquee>
        </div>
      </StyledTabPanel>
      <StyledTabPanel
        value={currentTab}
        index={
          isPurchasableFAR && user?.info?.type === "CITIZEN"
            ? "1"
            : !isPurchasableFAR && user?.info?.type === "EMPLOYEE"
            ? "1"
            : isLandUse && user?.info?.type === "CITIZEN"
            ? "1"
            : "3"
        }
        style={{ marginBottom: "30px" }}
      >
        {user?.info?.type === "EMPLOYEE" && formData?.applicationType != "FORM_PURCHASABLE_FAR" && (
          <React.Fragment>
            {showTimeLine && workflowDetails?.data?.timeline?.length > 0 && (
              <React.Fragment>
                <BreakLine />
                {(workflowDetails?.isLoading || isDataLoading) && <Loader />}
                {!workflowDetails?.isLoading && !isDataLoading && (
                  <Fragment>
                    <CardSectionHeader style={{ marginBottom: "16px", marginTop: "32px" }}>
                      {t("ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS")}
                    </CardSectionHeader>
                    {workflowDetails?.data?.timeline && workflowDetails?.data?.timeline?.length === 1 ? (
                      <Card style={{ backgroundColor: "aliceblue", borderRadius: "20px" }}>
                        <CheckPoint
                          isCompleted={true}
                          label={t(`${timelineStatusPrefix}${workflowDetails?.data?.timeline[0]?.state}`)}
                          customChild={getTimelineCaptions(workflowDetails?.data?.timeline[0])}
                        />
                      </Card>
                    ) : (
                      <ConnectingCheckPoints>
                        {workflowDetails?.data?.timeline &&
                          // workflowDetails?.data?.timeline.map((checkpoint, index, arr) => {
                          [...new Set(workflowDetails.data.timeline.map((checkpoint) => checkpoint?.status))].map((uniqueStatus, index) => {
                            // Filter the timeline for checkpoints with the unique status
                            const checkpoint = workflowDetails.data.timeline.find((item) => item.status === uniqueStatus);
                            // console.log("workflowDetails?.data?.timeline", workflowDetails?.data?.timeline)
                            return (
                              <React.Fragment key={index}>
                                <Card style={{ backgroundColor: "aliceblue", borderRadius: "20px" }}>
                                  <CheckPoint
                                    keyValue={index}
                                    isCompleted={index === 0}
                                    info={checkpoint.comment}
                                    label={t(
                                      `${timelineStatusPrefix}${
                                        checkpoint?.performedAction === "REOPEN" ? checkpoint?.performedAction : checkpoint?.[statusAttribute]
                                      }`
                                    )}
                                    customChild={getTimelineCaptions(checkpoint)}
                                  />
                                </Card>
                              </React.Fragment>
                            );
                          })}
                      </ConnectingCheckPoints>
                    )}
                  </Fragment>
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        {user?.info?.type === "CITIZEN" && formData?.applicationType != "FORM_PURCHASABLE_FAR" && (
          <React.Fragment>
            <BPAApplicationTimeline application={formData} id={formData?.applicationNo} />
          </React.Fragment>
        )}
        {formData?.applicationType === "FORM_PURCHASABLE_FAR" && (
          <React.Fragment>
            <Card
              style={{
                height: "500px",
                backgroundColor: "#F7F7F7",
              }}
            >
              <div style={{ overflow: "scroll", height: "450px" }}>
                <AllRemarksList remarkDataResps={workflowDetails?.data} />
              </div>
            </Card>
          </React.Fragment>
        )}
      </StyledTabPanel>
      {(isApprovedOwnerReg || isLandUse) && (
        <StyledTabPanel
          value={currentTab}
          index={isLandUse && user?.info?.type === "EMPLOYEE" ? "2" : isLandUse && user?.info?.type === "CITIZEN" ? "2" : "4"}
          style={{ marginBottom: "30px" }}
        >
          {user?.info?.type != "CITIZEN" && (
            <div>
              {/* <NocProvider> */}
              {isApprovedOwnerReg ? (
                <EMOCheckList />
              ) : (
                <LandUseNOC
                  formData={formData}
                  role={"EMPLOYEE"}
                  setOfficerNocDetails={setOfficerNocDetails}
                  setCurrentTab={handleChange}
                  setIsNoNoc={setIsNoNoc}
                />
                // <LandUseNOC2 formData={formData} role={"EMPLOYEE"} />
              )}
              {/* </NocProvider> */}
              {!isApprovedOwnerReg && !isLandUse && (
                <div style={{ marginTop: "10px" }}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checked}
                          onChange={handleChangeCheckBox}
                          inputProps={{ "aria-label": "confirmation by officer, filled details are accurate" }}
                        />
                      }
                      label="I have reviewed the NOC checklist and confirm that the details I have provided are accurate and complete."
                    />
                  </FormGroup>
                </div>
              )}
            </div>
          )}
          {/* {user?.info?.type === "CITIZEN" && formData?.status === "APPROVED" && <ViewLandUseNoc itemData={formData} />} */}
          {user?.info?.type === "CITIZEN" && formData?.status === "APPROVED" && <LandUseNOC formData={formData} role="APPROVED_CITIZEN" />}
        </StyledTabPanel>
      )}
      {isPurchasableFAR && (
        <StyledTabPanel value={currentTab} index={isPurchasableFAR && user?.info?.type === "CITIZEN" ? "2" : "4"} style={{ marginBottom: "30px" }}>
          <div>
            {user?.info?.type === "CITIZEN" ? (
              <ChecklistFarCitizen formData={formData} />
            ) : (
              <PurchasableFarChecklist
                formData={formData}
                lastEmpRole={userRolesArray?.[0]?.name}
                setRemarksData={setRemarksData}
                setCurrentTab={handleChange}
              />
            )}
          </div>
        </StyledTabPanel>
      )}
      {isPurchasableFAR && (
        <StyledTabPanel value={currentTab} index={isPurchasableFAR && user?.info?.type === "CITIZEN" ? "3" : "5"}>
          {/* "AA", "AAP", "AP", "SAP", "CAP", "DM", "ATP", "TP", Commented roles in the case of AVP */}
          {["JE"].includes(userRolesArray?.[0]?.code) && (
            <div>
              <FarDetails
                formData={formData}
                setCurrentTab={handleChange}
                farDetails={farDetails}
                setFarDetails={setFarDetails}
                empRole={userRolesArray?.[0]}
              />
            </div>
          )}

          {!["AA", "AAP", "AP", "SAP", "CAP", "DM", "ATP", "TP", "JE"].includes(userRolesArray?.[0]?.code) && (
            <React.Fragment>
              <CitizenFarDetails formData={formData} />

              {actions?.[0]?.action === "MAKE_PAYMENT" && (
                <div style={{ marginTop: "15px" }}>
                  <FarPaymentOption tenantId={tenantId} formData={formData} setFetchedPaymentData={setFetchedPaymentData} />

                  {fetchedPaymentData?.FeeInstallment?.[0]?.amount && (
                    <FarPaymentDisplay paymentDetails={fetchedPaymentData} totalAmount={formData?.taxHeadEstimates?.[0]?.estimateAmount} />
                  )}
                  {
                    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                      <Box gridColumn="span 2"></Box>
                      <Box gridColumn="span 8"></Box>
                      <Box gridColumn="span 2">
                        <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangePayment}>
                          Proceed to Pay
                        </Button>
                      </Box>
                    </Box>
                  }
                </div>
              )}
            </React.Fragment>
          )}
        </StyledTabPanel>
      )}
      {isLandUse && formData?.descriptionOfLand?.selectLandUse == "Conditional Permissible" && (
        <StyledTabPanel value={currentTab} index={isLandUse && user?.info?.type === "EMPLOYEE" && "3"} style={{ marginBottom: "30px" }}>
          {user?.info?.type != "CITIZEN" && (
            <SelectMandatoryConditions2 setMandatoryCondition={setMandatoryCondition} tenantId={tenantId} setCurrentTab={handleChange} />
          )}
        </StyledTabPanel>
      )}
      <StyledTabPanel
        value={currentTab}
        index={
          user?.info?.type === "CITIZEN"
            ? "4"
            : isPurchasableFAR && user?.info?.type === "EMPLOYEE"
            ? "6"
            : isLandUse && formData?.descriptionOfLand?.selectLandUse !== "Conditional Permissible"
            ? "3"
            : "4"
        }
        style={{ marginBottom: "30px" }}
      >
        <div>
          {user?.info?.type !== "CITIZEN" && <ChatBoard formData={formData} />}
          {user?.info?.type === "CITIZEN" && <ChatboardCorrespondenceApplicant formData={formData} />}
        </div>
      </StyledTabPanel>

      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </React.Fragment>
  );
};

export default FormSummary;
